module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAR5JREFUOBG1Ur1KA0EQ/uYiYp/OrBEEK8kDKMTGN9BC1OeQbOzNrYg+hg+iD2AhVoJgNHb2NrfjzMaTickdV+jAsst+PzO39wH/WS5wT1ddj6U6EAUOvvGHKl5WBTS9/1uDtZyPmJmquiumHIvPTBAjTlzAlSXYs8txrRx7N2PQXsYhGDsu54El6dmN2Mu2nTgGnBu3M+I2M+5AuMwY68qNhBcxPiVCf3JGH0YvtAW1Ebj7WeBWwInCDHRWWth99jT+TU8GZVjePP38727grSLKJFKtDP2xp8dSbPnTIC0IjApWc95TkRUnE8OvTeL7kO7LrlX71CDDkzzcwJ3L1zYoScq+POiFUtMbpIAEHCNis4EekIavHjdE1KxjnekXKo5d8bATPDcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/icons/ic_btn_download.png
// module id = uwyC
// module chunks = 83